import { Check, Trophy, XCircle } from "lucide-react";
import { STATUSES } from "@/lib/constants";

const PIPELINE = STATUSES.slice(0, 4);

const Step = ({ s, index, current, done, onSelect, last }) => (
  <li className="relative flex-1">
    {!last && <span className={`absolute left-4 top-4 hidden h-0.5 w-full sm:block ${done ? "bg-[color:var(--brand)]" : "bg-border"}`} />}
    {!last && <span className={`absolute left-4 top-8 h-full w-0.5 sm:hidden ${done ? "bg-[color:var(--brand)]" : "bg-border"}`} />}
    <button type="button" onClick={() => onSelect(s.key)} data-testid={`status-step-${s.key}`} aria-current={current ? "step" : undefined}
      className="relative flex min-h-12 w-full items-center gap-3 py-1 text-left sm:flex-col sm:items-start sm:gap-2">
      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold ring-4 ring-card transition-colors ${
        current ? "bg-[color:var(--brand)] text-white" : done ? "bg-[color:var(--brand)] text-white" : "bg-muted text-muted-foreground"}`}>
        {done && !current ? <Check className="h-4 w-4" /> : index + 1}
      </span>
      <span className={`text-sm ${current ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{s.label}</span>
    </button>
  </li>
);

export const StatusTimeline = ({ value, onChange }) => {
  const idx = PIPELINE.findIndex((s) => s.key === value);
  const closed = value === "won" || value === "lost";
  return (
    <div data-testid="lead-status-timeline">
      <ol className="flex flex-col sm:flex-row">
        {PIPELINE.map((s, i) => (
          <Step key={s.key} s={s} index={i} current={s.key === value} done={closed || i < idx} onSelect={onChange} last={i === PIPELINE.length - 1} />
        ))}
      </ol>
      <div className="mt-4 grid grid-cols-2 gap-2">
        <button type="button" onClick={() => onChange("won")} data-testid="status-step-won"
          className={`flex h-12 items-center justify-center gap-2 rounded-xl border text-sm font-semibold transition-colors ${
            value === "won" ? "border-emerald-600 bg-emerald-600 text-white" : "bg-card text-emerald-700 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-500/10"}`}>
          <Trophy className="h-4 w-4" /> Won
        </button>
        <button type="button" onClick={() => onChange("lost")} data-testid="status-step-lost"
          className={`flex h-12 items-center justify-center gap-2 rounded-xl border text-sm font-semibold transition-colors ${
            value === "lost" ? "border-slate-500 bg-slate-500 text-white" : "bg-card text-muted-foreground hover:bg-muted"}`}>
          <XCircle className="h-4 w-4" /> Lost
        </button>
      </div>
    </div>
  );
};
